<template>
  <el-table
    ref="table"
    height="100%"
    show-summary
    :data="data"
    :summary-method="getSummaries"
  >
    <el-table-column label="日期" prop="day" width="120"></el-table-column>

    <el-table-column v-if="!device.id" label="设备">
      <el-table-column
        v-for="dev in devs"
        :key="dev.id"
        :label="dev.name"
        :prop="`dev-${dev.id}`"
      >
        <template slot-scope="prop">
          {{ getDev(prop.row, dev.id) }}
        </template>
      </el-table-column>
    </el-table-column>

    <el-table-column v-else :label="device.name">
      <el-table-column
        v-for="insect in insects"
        :key="insect.id"
        :label="insect.name"
        :prop="`insect-${insect.id}`"
      >
        <template slot-scope="prop">
          {{ getIns(prop.row, insect.id) }}
        </template>
      </el-table-column>
    </el-table-column>
  </el-table>
</template>

<script>
import _ from 'lodash'
import { export_table_to_excel as exceljs } from '@/utlis/exportExcel'

export default {
  props: { data: Array, insects:Array, devs: Array, device: Object },
  methods: {
    getDev(row, devId) {
      let d = row.devices.find(d => d.id === devId)
      let v = d ? d.count : 0
      return v || ''
    },
    getIns(row, id) {
      let d = row.devices.find(d => d.id === this.device.id)
      if (!d) return ''
      let ins = d.insects.find(ii => ii.id === id)
      let v = ins ? ins.count : 0
      return v || ''
    },
    getSummaries({ columns, data }) {
      const sums = []
      const devId = this.device.id

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (!column.property) return

        let [type, id] = column.property.split('-')
        if (type === 'dev') {
          sums[index] = _.sumBy(data, o => {
            let dev = o.devices.find(d => d.id === +id)
            return dev.count
          })
        } else {
          sums[index] = _.sumBy(data, o => {
            let dev = o.devices.find(d => d.id === devId) || { insects: [] }
            let ins = dev.insects.find(i => i.id === +id)
            return ins ? ins.count : 0
          })
        }
      })

      return sums
    },
    exportExcel(title) {
      exceljs(this.$refs.table.$el, title)
    }
  }
}
</script>

<style lang="css" scoped></style>
